export const getDealItemRate = (item, dealLme) => {
  if (item.priceMode !== "UnFixed") return Number(item.rate || 0);
  const lme = Number(dealLme || item.lme || 0);
  // priceAdjustmentValue = "Per Of LME" (always a percentage of LME).
  // priceAdjustmentType = "Disc&Prem" (a flat +/- amount added on top).
  const perOfLme = Number(item.priceAdjustmentValue || 0);
  const discPrem = Number(item.priceAdjustmentType || 0);
  return (lme * perOfLme / 100) + discPrem;
};

export const calculateDealPayment = (items, form, allContainerItemsSame) => {
  // Shared item quantities describe one container; separate items already
  // describe the quantities for the deal.
  const containerMultiplier = allContainerItemsSame ? Number(form.noOfContainer) : 1;
  const totalAmount = items.reduce((sum, item) => (
    sum + Number(item.quantity || 0) * getDealItemRate(item, items[0]?.lme)
  ), 0) * containerMultiplier;
  const roundCurrency = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;
  let advanceAmount = 0;

  if (form.paymentType === "ADVANCE_FULL") {
    advanceAmount = roundCurrency(totalAmount);
  } else if (form.paymentType === "CUSTOM") {
    advanceAmount = roundCurrency(form.advanceIsPercent
      ? Number(items[0]?.lme || 0) * Number(form.totalQty || 0) * Number(form.advancePayment || 0) / 100
      : Number(form.advancePayment || 0));
  }

  return { advanceAmount, balanceAmount: roundCurrency(totalAmount - advanceAmount) };
};
